import Vue from "vue";
import Axios from "axios"
import store from '@/_store';
import PubNubVue from 'pubnub-vue';

function authorized(to, from, next) {
  if (localStorage.token) {
    Axios({
      method: 'get',
      url: store.state.api.auth + 'auth',
      headers: {
        authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then(response => {
        store.commit('user/userCommit', {
          firstname: response.data.firstname,
          lastname: response.data.surname,
          email: response.data.email
        })
      })
      .then(() => {
        Vue.use(PubNubVue, {
          subscribeKey: 'sub-c-39bd89b6-a130-11eb-bd5f-5e89266287f8',
          publishKey: 'pub-c-298278ab-bf2c-42f3-9d6b-e2357d21915c',
          uuid: store.state.user.data.email,
          ssl: true,
          restore: true
        })
        next();
      })
      .catch(err => {
        console.log(err);
        localStorage.token = '';
        next('/welcome');
      });
  } else {
    next('/welcome');
  }
}

function publicAccess(to, from, next) {
  if (localStorage.token) {
    Axios({
      method: 'get',
      url: store.state.api.auth + 'auth',
      headers: {
        authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then(response => {
        store.commit('user/userCommit', {
          firstname: response.data.firstname,
          lastname: response.data.surname,
          email: response.data.email
        })
      })
      .then(() => {
        Vue.use(PubNubVue, {
          subscribeKey: 'sub-c-39bd89b6-a130-11eb-bd5f-5e89266287f8',
          publishKey: 'pub-c-298278ab-bf2c-42f3-9d6b-e2357d21915c',
          uuid: store.state.user.data.email,
          ssl: true,
          restore: true
        })
        next('/');
      })
      .catch(err => {
        console.log(err);
        localStorage.token = '';
        next('/welcome');
      });
  } else {
    next();
  }
}

export {
  Vue,
  Axios,
  store,
  authorized,
  publicAccess
}
